import { createAction } from 'redux-actions'
import Api from '../Api'

import { SAVE_RIDER } from './rider'

export const CREATE_RIDER_STAGEPLAN = createAction('CREATE_RIDER_STAGEPLAN')
export const EDIT_RIDER_STAGEPLAN = createAction('EDIT_RIDER_STAGEPLAN')
export const VIEW_RIDER_STAGEPLAN = createAction('VIEW_RIDER_STAGEPLAN')
export const DELETE_RIDER_STAGEPLAN = createAction('DELETE_RIDER_STAGEPLAN')

export const createRiderStageplan = (riderId, stageplan) => {
  return (dispatch) => {
    dispatch(SAVE_RIDER())

    return dispatch(CREATE_RIDER_STAGEPLAN(Api.createRiderStageplan(riderId, stageplan)))
  }
}

export const editRiderStageplan = (stageplan) => {
  return (dispatch) => {
    dispatch(SAVE_RIDER())

    return dispatch(EDIT_RIDER_STAGEPLAN(Api.editRiderStageplan(stageplan)))
  }
}

export const viewRiderStageplan = (stageplanId) => {
  return (dispatch) => {
    dispatch(SAVE_RIDER())

    return dispatch(VIEW_RIDER_STAGEPLAN(Api.viewRiderStageplan(stageplanId)))
  }
}

export const deleteRiderStageplan = (stageplanId) => {
  return (dispatch) => {
    dispatch(SAVE_RIDER())

    return dispatch(DELETE_RIDER_STAGEPLAN(Api.deleteRiderStageplan(stageplanId)))
  }
}



// WEBPACK FOOTER //
// ./src/actions/rider-stageplan.js